<template>
  <div class="border p-2">
    <h6>
      NOTE: The USERS file is now a CSV file. Please do the following before
      you upload it:
    </h6>
    <ol>
      <li>Open the CSV Users file with Microsoft Excel.</li>
      <li>Click on File > Save As.</li>
      <li>Select <strong>Excel Workbook(*xlsx)</strong> from the file type dropdown menu.</li>
      <li>Click Save.</li>
      <li>Change the name of the worksheet to <strong>Sheet1.</strong></li>
      <li>Save your changes.</li>
    </ol>
  </div>
</template>


<script>
export default {
  name: "CSVToExcelInstructions",

  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style>
</style>
